import { useState, useEffect } from 'react';
import { Button, Col, Row, Modal, Progress } from "antd";

const LoadRxOrder = ({
  isRxExam,
  setIsRxExam,
  handleInitExam,
}) => {
  const { loading, status, showModal } = isRxExam;
  const [loadPercent, setLoadPercent] = useState(0);

  const handleLoadPercent = () => {
    let interval;

    if (loading && !status && showModal) {
      setLoadPercent(0);

      interval = setInterval(() => {
        setLoadPercent(previousPercent => {
          if (previousPercent < 99) {
            return previousPercent + 1;
          }

          return previousPercent;
        });
      }, 15);
    }

    return () => clearInterval(interval);
  };

  useEffect(() => {
    handleLoadPercent();
  }, [loading, status]);

  useEffect(() => {
    if (!loading && (status === 'success' || status === 'exists') && loadPercent === 99) {
      setTimeout(() => {
        setLoadPercent(100);
      }, 1000);
    }
  }, [loading, status, loadPercent]);


  const handleLoadManually = () => {
    closeModal();
    handleInitExam({ manually: true });
  };

  const modalContent = (loading, status) => {
    if (loadPercent < 100 && status !== 'failed') {
      return (
        <Row justify='center'>
          <Col lg={24} xs={24}>
            <p className='text-center'>Cargando</p>
          </Col>
          <Col lg={14} xs={24} className='mt-10'>
            <Progress
              percent={loadPercent}
            />
          </Col>
        </Row>
      );
    }

    if (!loading && status === 'success' && loadPercent === 100) {
      setTimeout(() => {
        closeModal();
      }, 3000);

      return (
        <Row justify='center'>
          <Col>
            <span className='icon-brand-feedback' />
          </Col>
          <Col lg={24} xs={24} className='mt-10'>
            <p className='text-center'>¡Orden enviada con éxito!</p>
          </Col>
        </Row>
      );
    }

    if (!loading && status === 'exists' && loadPercent === 100) {
      setTimeout(() => {
        closeModal();
      }, 3000);

      return (
        <Row justify='center'>
          <Col>
            <span className='icon-brand-feedback' />
          </Col>
          <Col lg={24} xs={24} className='mt-10'>
            <p className='text-center'>Orden existente recuperada</p>
          </Col>
        </Row>
      );
    }

    if (!loading && status === 'failed') {
      return (
        <Row justify='center'>
          <Col>
            <span className='icon-error-rounded' />
          </Col>
          <Col lg={24} xs={24} className='mt-10 mb-10'>
            <p className='text-center'>¡Envío de orden fallida!</p>
          </Col>
          <Col lg={13} xs={24}>
            <Button
              className='cmt-button primary'
              type='primary'
              onClick={handleInitExam}
            >
              Reintentar envío
            </Button>
          </Col>
          <Col lg={13} xs={24} className='mt-15'>
            <Button
              className='cmt-button primary outline'
              type='primary'
              onClick={handleLoadManually}
            >
              Cargar manualmente
            </Button>
          </Col>
        </Row>
      );
    }

    if (loading && status === 'failed') {
      return (
        <Row justify='center'>
          <Col>
            <span className='icon-alert-triangle-bold' />
          </Col>
          <Col lg={24} xs={24} className='mt-10'>
            <p className='text-center'>Orden en proceso. <br /> Por favor, espera unos minutos.</p>
          </Col>
        </Row>
      );
    }
  };

  const closeModal = () => {
    setIsRxExam(isRxExam => ({
      ...isRxExam,
      loading: false,
      status: null,
      showModal: false,
    }));
  };


  return (
    <Modal
      open={showModal}
      footer={false}
      centered
      closable
      onCancel={closeModal}
      className='load-rx-order-modal'
      responsive
    >
      {
        modalContent(loading, status)
      }
    </Modal>
  );
};

export default LoadRxOrder;